import { render } from "./AudioPage.vue?vue&type=template&id=ed56fb4a&scoped=true"
import script from "./AudioPage.vue?vue&type=script&lang=js"
export * from "./AudioPage.vue?vue&type=script&lang=js"

import "./AudioPage.vue?vue&type=style&index=0&id=ed56fb4a&scoped=scoped&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed56fb4a"]])

export default __exports__